<template>
  <div id="app">

    <sc-menu  v-if="$route.name != 'login' && $route.query.token" />
    <router-view > </router-view>
    <!-- <div v-loading="!espera" element-loading-text="Cargando" v-if="$route.name !== 'admin'" :style="!espera ? 'marginTop:27vh' : ''">
    </div> -->
    <!-- <v-idle @idle="onidle" @remind="onremind" :loop="true" :wait="1" :duration="60*240" v-if="$route.name != 'login'" /> -->
  </div>
</template>

<script>
import scMenu from "@/components/scMenu.vue";
// import { EventBus } from "./event-bus";
// import { HTTP, SC } from "@/axios.js";

export default {
  name: "app",
  components: {
    scMenu,
  },
  data() {
    return {
    
      cliente: {},
      isValid: false,
      invitacion: false,
      espera: false
    };
  },

  created() {
  
  },

}

   
</script>

<style>
body {
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  word-break: break-word !important;
}

.el-upload__tip {
  font-size: 12px;
  color: #606266;
  margin-top: 7px;
  word-break: break-word !important;
  line-height: 1.2;
}

.v-idle {
  font-size: 12px;
  position: absolute;
  top:0px;
  right: 5px;
  color:white;
 
}
</style>
